export class InvalidOrderError extends Error {
    public readonly errorDescription?: string;

    constructor(errorDescription?: string) {
        super('INVALID_ORDER_ERROR');
        this.errorDescription = errorDescription;
    }
}
